// Single source of truth for VK Tours brand details used across the public site.
export const BRAND = {
  name: 'VK Tours',
  // TODO: replace with the self-hosted logo file once copied out of Emergent
  logo: '/images/vk-tours-logo.png',
  phone: '+91 96188 49933',
  phoneLink: 'tel:+919618849933',
  landline: '0866 455 3285',
  landlineLink: 'tel:+918664553285',
  email: 'info@vktours.com',
  whatsapp: 'https://wa.me/919716222279',
  instagram: 'https://www.instagram.com/vktoursglobal/',
  youtube: 'https://www.youtube.com/@VKTOURS-pp8dj',
  youtubeReviews: 'https://www.youtube.com/playlist?list=PLKC--wbGdxYM',
  googleReviews: 'https://maps.app.goo.gl/4fTdTfuMWnKECwBG9',
  address: '1st Floor, Sai Plaza, Sanath Nagar, Above APCOB Bank, Kanuru, Vijayawada, Andhra Pradesh 520007',
  offices: 'INDIA: Vijayawada, Delhi • USA • Maldives',
  googleRating: '4.8',
};

export const waLink = (text) => `${BRAND.whatsapp}?text=${encodeURIComponent(text || 'Hi VK Tours, I would like a holiday quote.')}`;

export const unsplash = (id, w = 1600) => `https://images.unsplash.com/${id}?w=${w}&q=80&auto=format&fit=crop`;

export const toNumber = (v) => {
  if (v === null || v === undefined) return null;
  const n = Number(String(v).replace(/[^0-9.]/g, ''));
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const inr = (n) => (n ? '₹' + Math.round(n).toLocaleString('en-IN') : 'On request');

export const NAV = {
  international: [
    { name: 'Dubai', path: '/dubai-tour-packages' },
    { name: 'Maldives', path: '/maldives-honeymoon-packages' },
    { name: 'Thailand', path: '/thailand-tour-packages' },
    { name: 'Bali', path: '/bali-holiday-packages' },
    { name: 'Singapore', path: '/singapore-tour-packages' },
    { name: 'Malaysia', path: '/malaysia-tour-packages' },
    { name: 'Vietnam', path: '/vietnam-tour-packages' },
    { name: 'Sri Lanka', path: '/sri-lanka-tour-packages' },
    { name: 'Nepal', path: '/nepal-tour-packages' },
    { name: 'Bhutan', path: '/bhutan-tour-packages' },
    { name: 'Mauritius', path: '/mauritius-honeymoon-packages' },
    { name: 'Europe', path: '/europe-tour-packages' },
    { name: 'USA', path: '/usa-tour-packages' },
    { name: 'Australia', path: '/australia-tour-packages' },
    { name: 'Japan', path: '/japan-tour-packages' },
    { name: 'South Korea', path: '/south-korea-tour-packages' },
    { name: 'Egypt', path: '/egypt-tour-packages' },
    { name: 'Jordan', path: '/jordan-tour-packages' },
    { name: 'Azerbaijan', path: '/azerbaijan-tour-packages' },
    { name: 'Georgia', path: '/georgia-tour-packages' },
    { name: 'Russia', path: '/russia-tour-packages' },
  ],
  india: [
    { name: 'Kashmir', path: '/kashmir-tour-packages' },
    { name: 'Kerala', path: '/kerala-tour-packages' },
    { name: 'Rajasthan', path: '/rajasthan-tour-packages' },
    { name: 'Goa', path: '/goa-holiday-packages' },
    { name: 'Himachal Pradesh', path: '/himachal-tour-packages' },
    { name: 'Uttarakhand', path: '/uttarakhand-tour-packages' },
    { name: 'Leh Ladakh', path: '/ladakh-bike-tour-packages' },
    { name: 'North East India', path: '/northeast-india-tour-packages' },
    { name: 'Andaman', path: '/andaman-tour-packages' },
    { name: 'AP & Telangana', path: '/andhra-telangana-tour-packages' },
    { name: "Karnataka", path: '/karnataka-tour-packages' },
    { name: "Tamil Nadu", path: '/tamil-nadu-tour-packages' },
    { name: "Uttar Pradesh", path: '/uttar-pradesh-tour-packages' },
    { name: "Madhya Pradesh", path: '/madhya-pradesh-tour-packages' },
    { name: "Maharashtra", path: '/maharashtra-tour-packages' },
    { name: "Odisha", path: '/odisha-tour-packages' },
    { name: "Gujarat", path: '/gujarat-tour-packages' },
    { name: "Lakshadweep", path: '/lakshadweep-tour-packages' },
    { name: 'Golden Triangle & more', path: '/india-tour-packages' },
  ],
  themes: [
    { name: 'Honeymoon', path: '/honeymoon-packages' },
    { name: 'Family Holidays', path: '/family-holiday-packages' },
    { name: 'Pilgrimage', path: '/pilgrimage-tour-packages' },
    { name: 'Adventure', path: '/adventure-tour-packages' },
    { name: 'Heritage', path: '/heritage-tour-packages' },
    { name: 'Luxury', path: '/luxury-holiday-packages' },
    { name: 'Group Tours', path: '/group-tours' },
  ],
  services: [
    { name: 'Visa Assistance', path: '/travel-services/visa-assistance' },
    { name: 'Flights', path: '/flights' },
    { name: 'Cruises', path: '/travel-services/cruise' },
    { name: 'Car Rental', path: '/travel-services/car-rental' },
  ],
};
